import React from 'react'

import { withTranslation } from 'react-i18next'
import './CreateChannelHeader.scss'
import { Button } from 'antd'
import NewHeader from '../../../../../components/NewHeader'

function CreateChannelHeader({
  t,
  isMarketplaceView,
  onToggleMarketplace,
  channelId
}) {
  return (
    <div className="shl-create-channel-header">
      <div class="marketplace-head">
        <h2 className="shl-create-channel-header-title">
          {t('v3:create_a_new_channel')}
        </h2>
        {!isMarketplaceView && (
          <Button
            size="large"
            shape="round"
            className="button-blue_color"
            onClick={onToggleMarketplace}
            disabled={!channelId}
          >
            {t('buttons:market_place').toUpperCase()}
          </Button>
        )}
      </div>
      <NewHeader />
    </div>
  )
}

export default withTranslation()(CreateChannelHeader)
